var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1319,
    height: 372,
    viewBox: "0 0 1319 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M461.602 110.946C478.227 44.9324 714.516 67.606 819.308 77.6307C924.099 87.6555 1010.22 155.997 993.594 222.01C976.969 288.023 820.427 215.225 715.636 205.2C610.845 195.175 444.976 176.959 461.602 110.946Z",
    fill: "url(#paint0_linear_203_2)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M990.604 202.489C1024.32 265.979 797.016 311.761 696.232 332.092C595.447 352.423 468.427 315.555 434.709 252.066C400.991 188.576 594.063 209.75 694.848 189.419C795.632 169.088 956.886 139 990.604 202.489Z",
    fill: "url(#paint1_linear_203_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M799.822 109.93C799.822 176.734 610.202 325.667 504.156 325.667C398.11 325.667 296 266.276 296 199.472C296 132.668 381.967 78.5127 488.013 78.5127C594.059 78.5127 799.822 43.1265 799.822 109.93Z",
    fill: "url(#paint2_linear_203_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.784 84.28V280.12C219.784 282.136 220.936 283 222.664 283H227.56C229.288 283 230.44 282.136 230.44 280.12V84.28C230.44 82.552 229.288 81.4 227.56 81.4H222.664C220.936 81.4 219.784 82.552 219.784 84.28ZM390.469 81.4H334.309H267.493C265.765 81.4 264.613 82.552 264.613 84.28V88.312C264.613 90.328 265.765 91.192 267.493 91.192H323.653V280.12C323.653 282.136 324.805 283 326.533 283H331.429C333.157 283 334.309 282.136 334.309 280.12V91.192H390.469C392.197 91.192 393.349 90.328 393.349 88.312V84.28C393.349 82.552 392.197 81.4 390.469 81.4ZM470.821 238.648L545.413 121.144C547.141 118.264 548.005 115.672 548.005 112.216V88.6C548.005 83.992 545.413 81.4 540.805 81.4H419.845C415.237 81.4 412.645 83.992 412.645 88.6V118.552C412.645 123.16 415.237 125.752 419.845 125.752H488.389L413.797 243.256C412.069 246.136 411.205 248.728 411.205 252.184V275.8C411.205 280.408 413.797 283 418.405 283H542.245C546.853 283 549.445 280.408 549.445 275.8V245.848C549.445 241.24 546.853 238.648 542.245 238.648H470.821ZM636.855 134.968C591.351 134.968 559.671 168.088 559.671 211C559.671 253.912 590.199 287.032 638.007 287.032C667.383 287.032 690.999 274.072 702.231 249.016C704.535 244.408 701.655 240.952 696.471 240.952L668.823 241.24C665.079 241.24 662.775 242.68 659.895 244.984C654.711 249.304 646.647 252.184 638.583 252.184C623.319 252.184 610.071 245.56 604.887 228.28H665.943H701.079C705.399 228.28 708.279 226.264 708.855 221.656C709.143 218.2 709.431 214.744 709.431 211C709.431 167.512 678.903 134.968 636.855 134.968ZM604.599 195.448C608.919 181.336 620.151 173.272 636.567 173.272C649.239 173.272 661.911 179.32 666.231 195.448H604.599ZM812.385 145.048L788.769 221.08L761.409 144.76C759.969 141.016 757.377 139 753.345 139H722.241C717.057 139 714.753 142.456 716.481 147.352L767.169 280.696L749.889 332.536C748.161 337.72 750.753 340.6 755.937 340.6H787.041C791.073 340.6 794.241 338.872 795.393 334.84L857.601 147.064C859.329 141.88 856.737 139 851.553 139H820.449C816.417 139 813.537 141.016 812.385 145.048ZM923.841 242.68L975.393 171.832C977.409 168.952 978.273 166.36 978.273 162.904V146.2C978.273 141.592 975.681 139 971.073 139H876.033C871.425 139 868.833 141.592 868.833 146.2V172.12C868.833 176.728 871.425 179.32 876.033 179.32H920.385L868.833 250.168C866.816 253.048 865.953 255.64 865.953 259.096V275.8C865.953 280.408 868.545 283 873.153 283H973.953C978.561 283 981.153 280.408 981.153 275.8V249.88C981.153 245.272 978.561 242.68 973.953 242.68H923.841Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.54 309.248L1110.75 73.376L1132.06 80.576L1050.85 316.448L1029.54 309.248ZM1193.75 131.264L1285.91 189.152V205.568L1194.04 263.168L1181.08 242.72L1255.67 197.216L1181.08 151.424L1193.75 131.264Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.376 242.72L124.416 263.168L32.544 205.568V189.152L124.704 131.264L137.376 151.424L62.784 197.216L137.376 242.72Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_2",
    x1: 505.781,
    y1: 128.749,
    x2: 935.2,
    y2: 272.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EF83E",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_203_2",
    x1: 945.956,
    y1: 198.424,
    x2: 518.041,
    y2: 349.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E3EF8",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B156D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_203_2",
    x1: 729.304,
    y1: 89.5088,
    x2: 520.005,
    y2: 381.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EECF8",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1A056",
    stopOpacity: 0.17
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBg);
export default __webpack_public_path__ + "static/media/logo-bg.a9636846826e4cae7edceb079aa0bdc2.svg";
export { ForwardRef as ReactComponent };